import * as React from 'react'
import { t } from 'ttag'
import { ROUTES } from '../../common/Routes/routePaths'
import YumButton from '../../components/YumButton/YumButton'
import Typography from '@material-ui/core/Typography'
import { Box } from '@material-ui/core'
import { YumLanguageSelection } from '../../components/YumLanguageSelection/YumLanguageSelection'
import Grid from '@material-ui/core/Grid'
import { Card } from '../../components/Card/Card'
import './Welcome.scss'
import Loader from '../../components/Loader/Loader'
import { Lang, UserProfileDto } from '../../services/api.types'
import { openPrivacyPolicy, openTermsOfService } from '../../common/helpers/routeHelpers'
import { currentLang } from '../../i18nInit'
import YumGrid from '../../components/YumGrid/YumGrid'
import { DesktopSidebar } from '../../components/DesktopSidebar/DesktopSidebar'

//import BadgeLeft from './badges/g2-badge-left.svg'
//import BadgeRight from './badges/g2-badge-right.svg'

export interface IStateProps {
  authenticated: boolean
  userDto: UserProfileDto
}

export interface IDispatchProps {
  reLocate(): void
}

type IWelcomeProps = IStateProps & IDispatchProps

export const WelcomeSidebar = (props: { className?: string }) => {
  const secondTitle = t`We don't just
talk the talk`
  return currentLang === Lang.EN ? (
    <Box display={{ xs: 'none', md: 'block' }} style={{ background: '#F2F2F6', width: '50%' }}>
      <div style={{ padding: '100px', textAlign: 'center' }}>
        <Typography variant="h1" style={{ textAlign: 'center' }}>
          {secondTitle}
        </Typography>

        <Typography
          variant="subtitle1"
          style={{ textAlign: 'center' }}
        >{t`The recognition we have earned proves that we walk the walk.`}</Typography>

        <YumGrid style={{ marginTop: '30px', marginBottom: '30px' }}>
          <img
            style={{ width: '130px', height: '150px' }}
            width="130"
            height="150"
            src="https://resources.yumuuv.com/badges/first-badge.svg"
            alt="G2 first badge"
          />
          <img
            style={{ width: '130px', height: '150px' }}
            width="130"
            height="150"
            src="https://resources.yumuuv.com/badges/second-badge.svg"
            alt="G2 second badge"
          />
        </YumGrid>

        <Typography
          variant="subtitle1"
          style={{ textAlign: 'center' }}
        >{t`Join the YuMuuv community and experience the difference.`}</Typography>
      </div>
    </Box>
  ) : (
    <DesktopSidebar />
  )
}

export class Welcome extends React.Component<IWelcomeProps> {
  componentDidMount() {
    document.body.classList.add('show-illustration')
    this.props.reLocate()
  }

  componentDidUpdate() {
    if (this.props.authenticated) {
      this.props.reLocate()
    }
  }

  componentWillUnmount(): void {
    document.body.classList.remove('show-illustration')
  }

  render() {
    const title = t`Welcome
          to YuMuuv`
    return (
      <Card className="welcome pt-12">
        <Box className="welcome__inner" style={{ position: 'relative' }}>
          <Loader />
          <div className="welcome__form">
            <Box display={{ xs: 'block', md: 'none' }}>
              <Grid
                container
                alignItems="flex-start"
                justifyContent="flex-end"
                direction="row"
                style={{ height: 70, paddingTop: 15 }}
              >
                <YumLanguageSelection />
              </Grid>
            </Box>

            <Typography className={'h1-desktop-single-line'} variant="h1">
              {title}
            </Typography>

            <Typography
              variant="subtitle1"
              style={{ textAlign: 'center' }}
            >{t`Connect device. Be active. Enjoy progress.`}</Typography>

            <YumButton style={{ width: '225px', marginBottom: '16px' }} to={ROUTES.LOGIN.to}>{t`Log in`}</YumButton>
            <YumButton
              variant="outlined"
              style={{ width: '225px', marginBottom: '8px' }}
              to={ROUTES.SIGNUP.to}
            >{t`Sign up`}</YumButton>

            <Box display={{ xs: 'flex', md: 'none' }} justifyContent="center">
              <Box p="6px 15px 8px 15px" alignItems={'center'} alignContent="center">
                <a className={'link-blue'} href={undefined} onClick={openPrivacyPolicy}>{t`Privacy Policy`}</a>
              </Box>
            </Box>
            <Box display={{ xs: 'flex', md: 'none' }} justifyContent="center">
              <Box p="0 15px 8px 15px" alignItems={'center'} alignContent="center">
                <a
                  style={{ marginTop: 5 }}
                  className={'link-blue'}
                  href={undefined}
                  onClick={openTermsOfService}
                >{t`Terms of Service`}</a>
              </Box>
            </Box>
          </div>

          <Box display={{ xs: 'none', md: 'block' }} style={{ position: 'absolute', bottom: 20, left: 0, right: 0 }}>
            <Box display="flex" justifyContent="center">
              <Box p="6px 15px 8px 15px" alignItems={'center'} alignContent="center">
                <a
                  style={{ margin: '0 12px' }}
                  className={'link-blue'}
                  href={undefined}
                  onClick={openPrivacyPolicy}
                >{t`Privacy Policy`}</a>
                <a
                  style={{ margin: '0 12px' }}
                  className={'link-blue'}
                  href={undefined}
                  onClick={openTermsOfService}
                >{t`Terms of Service`}</a>
              </Box>
            </Box>
          </Box>
        </Box>
        <WelcomeSidebar />
      </Card>
    )
  }
}
